(ns sv.core.async
  #?(:clj
     (:require [clojure.core.async :as a])))

#?(:clj
   (defn cljs-env?
     "Take the &env from a macro, and tell whether we are expanding into cljs."
     [env]
     (boolean (:ns env))))

#?(:clj
   (defmacro if-cljs
     "Return then if we are generating cljs code and else for Clojure code.
      https://groups.google.com/d/msg/clojurescript/iBY5HaQda4A/w1lAQi9_AwsJ"
     [then else]
     (if (cljs-env? &env) then else)))

(defn throw-err [e]
  (when (instance? #?(:clj Throwable :cljs js/Error) e)
    (throw e))
  (when (:cognitect.anomalies/category e)
    (throw (ex-info (:cognitect.anomalies/message e
                                                  "error")
                    e)))
  e)

#?(:clj
   (defmacro <?
     "Like <! but throws errors."
     [ch]
     `(if-cljs
        (throw-err (cljs.core.async/<! ~ch))
        (throw-err (clojure.core.async/<! ~ch)))))

#?(:clj
   (defn <??
     "Like <!! but throws errors."
     [ch]
     (throw-err (clojure.core.async/<!! ch))))

#?(:clj
   (defmacro go-try
     "Like go but catches the first thrown error and returns it."
     [& body]
     `(if-cljs
        (cljs.core.async/go
          (try
            ~@body
            (catch js/Error e# e#)))
        (clojure.core.async/go
          (try
            ~@body
            (catch Throwable t# t#))))))

(comment
  ;; Examples:

  (<??
    (go-try
      #:cognitect.anomalies{:category :cognitect.anomalies/interrupted,
                            :message "Datomic Client Timeout"}
      ))

  (a/<!!
    (a/go
      (throw
        (ex-info
          "some error"
          #:cognitect.anomalies {:category :cognitect.anomalies/interrupted,
                                 :message "Datomic Client Timeout"}))))

  ;; exception is thrown:
  (<??
    (go-try
      (throw
        (ex-info
          "some error"
          #:cognitect.anomalies {:category :cognitect.anomalies/interrupted,
                                 :message "Datomic Client Timeout"}))
      ))


  )
